import { AuditLog } from 'pages/insights/auditLog/AuditLog'
import { AuditLogProvider } from 'pages/insights/auditLog/context/AuditLogContext'

export const AuditLogContainer: React.FC = () => {
  return (
    <AuditLogProvider>
      <AuditLog />
    </AuditLogProvider>
  )
}
